import { Trans } from "@lingui/macro";
import IconArrowLeft from "@mui/icons-material/ArrowLeft";
import { ApiEpBilling } from "@smp/api";
import { UiAlert, UiButton, UiGrid, UiLink, UiTypography } from "@smp/ui";
import { useSnackbar } from "notistack";
import { useMutation } from "react-query";

import { useFailureTranslator } from "@/hooks/use_failure_translator";

import { useStyles } from "./prepare.css";

export const Prepare = ({
  onClose,
  onSuccess,
}: {
  onClose: () => void;
  onSuccess: () => void;
}) => {
  const { failureTranslationGet } = useFailureTranslator();
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();

  const { isLoading, mutate } = useMutation(ApiEpBilling.Update.update, {
    onError: (error) => {
      enqueueSnackbar(failureTranslationGet(error), { variant: "error" });
    },
    onSuccess,
  });

  return (
    <UiGrid container spacing={2}>
      <UiGrid item xs={12}>
        <UiButton
          color="primary"
          onClick={onClose}
          startIcon={<IconArrowLeft />}
          variant="contained"
        >
          <Trans>Back</Trans>
        </UiButton>
      </UiGrid>
      <UiGrid item>
        <UiTypography>
          <Trans>SMMplanner grants you up to 100 free posts every month.</Trans>
        </UiTypography>
      </UiGrid>
      <UiGrid item>
        <UiAlert variant="info">
          <UiTypography>
            <Trans>
              The accounting period starts on the first day of every month.
            </Trans>
          </UiTypography>
          <UiTypography>
            <Trans>
              There is limit to free posts: you cannot accumulate/receive more
              than 100 free posts a month.
            </Trans>
          </UiTypography>
        </UiAlert>
      </UiGrid>
      <UiGrid item>
        <UiTypography>
          <Trans>Here you can collect free posts (or purchase them):</Trans>
        </UiTypography>
      </UiGrid>
      <UiGrid item xs={12}>
        <UiTypography>
          <Trans>
            1. Follow SMMplanner on social media:{" "}
            <UiLink
              href="https://www.facebook.com/smmplanner.ru"
              target="_blank"
            >
              Facebook
            </UiLink>
            ,{" "}
            <UiLink href="https://vk.com/smmplanner" target="_blank">
              VK
            </UiLink>
            ,{" "}
            <UiLink
              href="http://www.youtube.com/channel/UCMRGvjeSQODa0xXbn_Od2Wg"
              target="_blank"
            >
              YouTube
            </UiLink>
            ,{" "}
            <UiLink href="https://www.instagram.com/smmplanner" target="_blank">
              Instagram
            </UiLink>
            ,{" "}
            <UiLink href="https://twitter.com/smmplanner" target="_blank">
              Twitter
            </UiLink>
            ,{" "}
            <UiLink href="https://telegram.me/smmplanner" target="_blank">
              Telegram
            </UiLink>
            .
          </Trans>
        </UiTypography>
      </UiGrid>
      <UiGrid item xs={12}>
        <UiTypography>
          <Trans>2. Use the button below:</Trans>
        </UiTypography>
      </UiGrid>
      <UiGrid item>
        <UiButton
          color="primary"
          gutterBottom
          isLoading={isLoading}
          onClick={mutate}
          variant="contained"
        >
          <Trans>Get free posts</Trans>
        </UiButton>
      </UiGrid>
      <UiGrid item>
        <UiTypography className={classes.remarkText}>
          <Trans>
            * Not required to receive posts. We recommend subscribing to receive
            the latest news about SMMplanner and the social media world.
          </Trans>
        </UiTypography>
      </UiGrid>
    </UiGrid>
  );
};
